'use client';

import dynamic from 'next/dynamic';

export const Sanitize = dynamic(
  () => import('./Sanitize').then(({ Sanitize }) => ({ default: Sanitize })),
  { ssr: false }
);
